// extracted by mini-css-extract-plugin
export default {"Stripe":"StripePayForm_Stripe__1wo28","Stripe__button":"StripePayForm_Stripe__button__3xi3d"};